import { render } from "./infoPaciente.vue?vue&type=template&id=5926e4b4&scoped=true"
import script from "./infoPaciente.vue?vue&type=script&lang=js"
export * from "./infoPaciente.vue?vue&type=script&lang=js"

import "./infoPaciente.vue?vue&type=style&index=0&id=5926e4b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5926e4b4"]])

export default __exports__